import { useQuery } from '@tanstack/react-query';
import { getLocations } from '@/services/officeService';

export const useOffices = () => {
  const query = useQuery({
    queryKey: ['officeLocations'],
    queryFn: async () => {
      const response = await getLocations();
      const data = response?.data || response;
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.locations)) return data.locations;
      return [];
    },
    staleTime: 1000 * 60 * 5,
  });

  return {
    data: query.data || [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
